import { initFancybox } from "../../../../growtype/resources/scripts/plugins/fancybox/initFancybox";
import {
    imageWrapperIconImgToVideo
} from "@growtype-chat/partials/components/imageWrapperIconImgToVideo";

const unlockedContentStoragePrefix = 'growtype-child:unlocked-content:';

function scrollToUnlockedContentHash(container) {
    if (!window.location.hash) return;

    let targetId = window.location.hash.slice(1);
    try {
        targetId = decodeURIComponent(targetId);
    } catch (error) {
        return;
    }

    const target = document.getElementById(targetId);
    if (!target || !container.contains(target)) return;

    window.requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
}

function setUnlockedContentExpanded(toggle, container, isExpanded) {
    const contentId = toggle.getAttribute('aria-controls');
    const content = contentId ? document.getElementById(contentId) : null;
    if (!content || !container.contains(content)) return false;

    toggle.setAttribute('aria-expanded', String(isExpanded));
    content.hidden = !isExpanded;
    toggle.closest('.character-unlocked-section')
        ?.classList.toggle('is-content-collapsed', !isExpanded);

    const label = toggle.querySelector('.unlocked-content-toggle-label');
    if (label) {
        label.textContent = isExpanded
            ? toggle.dataset.hideLabel
            : toggle.dataset.showLabel;
    }

    return true;
}

function rememberUnlockedContentState(toggle, isExpanded) {
    const contentId = toggle.getAttribute('aria-controls');
    if (!contentId) return;

    try {
        const storageKey = unlockedContentStoragePrefix + contentId;
        if (isExpanded) {
            window.localStorage.removeItem(storageKey);
        } else {
            window.localStorage.setItem(storageKey, 'collapsed');
        }
    } catch (error) {
        // Storage can be unavailable in private or restricted browser contexts.
    }
}

function restoreUnlockedContentStates(container) {
    container.querySelectorAll('.unlocked-content-toggle').forEach((toggle) => {
        const contentId = toggle.getAttribute('aria-controls');
        if (!contentId) return;

        try {
            if (window.localStorage.getItem(unlockedContentStoragePrefix + contentId) === 'collapsed') {
                setUnlockedContentExpanded(toggle, container, false);
            }
        } catch (error) {
            // Keep the server-rendered expanded state when storage is unavailable.
        }
    });
}

function initUnlockedContentToggles(container) {
    container.addEventListener('click', (event) => {
        const toggle = event.target.closest('.unlocked-content-toggle');
        if (!toggle || !container.contains(toggle)) return;

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !isExpanded;
        if (!setUnlockedContentExpanded(toggle, container, nextExpanded)) return;

        rememberUnlockedContentState(toggle, nextExpanded);
    });
}

export function unlockedContentLoader() {
    const loader = document.getElementById('growtype-child-unlocked-content-container');
    if (!loader) return;

    const action = loader.dataset.action;
    const type = loader.dataset.type || 'character';
    if (!action) return;

    const ajaxUrl = window.growtype_child_ajax.url || window.growtype_child_ajax.ajax_url;
    initUnlockedContentToggles(loader);

    $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: {
            action: action,
            type: type,
        },
        success: function (response) {
            if (response.success) {
                const $container = $(loader);
                $container.html(response.data);
                restoreUnlockedContentStates(loader);

                $container.find('.growtype-theme-fancybox').each(function () {
                    initFancybox($(this));
                });

                imageWrapperIconImgToVideo($container);
                scrollToUnlockedContentHash(loader);

                // Trigger an event in case other scripts need to re-init (like lazy loading or audio players)
                document.dispatchEvent(new CustomEvent('growtype_child_unlocked_content_loaded', {
                    detail: { container: loader }
                }));
            } else {
                const message = (response.data && response.data.message) ? response.data.message : 'Error loading content.';
                $(loader).html('<p class="text-center py-5">' + message + '</p>');
            }
        },
        error: function () {
            $(loader).html('<p class="text-center py-5">Failed to load content. Please refresh the page.</p>');
        }
    });
}
